module.exports = __webpack_public_path__ + "img/ginko.aa8c639b.jpg";